/**
 * Конфигурация A/B тестирования
 */

export interface AbTestConfig {
  /** Уникальный ID теста */
  testId: string;

  /** Включен ли тест */
  enabled: boolean;

  /** Список страниц, на которых активен тест */
  pages: string[];
}

/** Реестр активных A/B тестов. Сейчас активных тестов нет. */
export const AB_TESTS: Record<string, AbTestConfig> = {};
